import clone from 'lodash/clone';
import set from 'lodash/set';

export const immutableSet = (state: any, path: number, value: any) => set(clone(state), path, value);
